export const defaultSort = 'STANDARD'

// initial state constructor
export default () => ({
  account: {},
  bookmarks: [],
  categories: [],
  csrfParam: null,
  csrfToken: null,
  headline: '',
  initialIntent: null,
  isSearchVisible: false,
  isSearchSticky: false,
  job: null,
  jobPinned: null,
  jobLoadingId: null,
  jobMarket: null,
  links: {},
  listActionVisible: null,
  loginErrorNoticeLink: null,
  modalComponent: null,
  modalOpen: false,
  modalProps: null,
  optInConsentHint: null,
  pageType: null,
  results: [],
  resultsCount: 0,
  resultsLoading: true,
  resultsLoadingKey: null,
  resultsKey: '',
  resultsPagination: null,
  resultsJobSelected: null,
  resultsJobUserSelected: false,
  resultsSidebar: null,
  resultsMatchingProfile: null,
  resultsFenceUrl: null,
  searchProfile: {
    customTags: [],
    tagKeys: []
  },
  searchContext: null,
  searchContextEvaluated: false,
  sort: defaultSort,
  user: {
    email: null,
    status: null
  },
  usedSearchMapping: false,
  searchMappingPath: null,
  typeAheadUrl: null,
  consent: {
    google: 'UNKNOWN',
    doo: 'UNKNOWN'
  },
  featureFlags: {},
  referrer: null
})
